export const CREATE_INCOME_RANGE = "CREATE_INCOME_RANGE"
export const CREATE_INCOME_RANGE_SUCCESS = "CREATE_INCOME_RANGE_SUCCESS"
export const CREATE_INCOME_RANGE_FAIL = "CREATE_INCOME_RANGE_FAIL"

export const UPDATE_INCOME_RANGE = "UPDATE_INCOME_RANGE"
export const UPDATE_INCOME_RANGE_SUCCESS = "UPDATE_INCOME_RANGE_SUCCESS"
export const UPDATE_INCOME_RANGE_FAIL = "UPDATE_INCOME_RANGE_FAIL"